import React from 'react';
import AppLogo from './AppLogo';
import './AppLogoLoader.css'; // Import the CSS file

interface AppLogoLoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
}

const AppLogoLoader: React.FC<AppLogoLoaderProps> = ({
  size = 'medium',
  text,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className="logo-animation">
        <AppLogo size={size} />
      </div>
      {text && (
        <p className="mt-4 text-white text-center loader-text">{text}</p>
      )}
    </div>
  );
};

export default AppLogoLoader; 